import * as Sentry from "@sentry/react";
import { QueryClient } from "@tanstack/react-query";
import { Link, RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import "./instrument";
import Providers from "./providers";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";

const queryClient = new QueryClient();

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultNotFoundComponent: () => {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p>¡No encontrado!</p>
        <Link className="text-blue-500" to="/">
          Inicio
        </Link>
      </div>
    );
  },
  defaultOnCatch(error) {
    Sentry.captureException(error);
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Providers queryClient={queryClient}>
      <RouterProvider router={router} />
    </Providers>,
  );
}
